const iconEyes = document.querySelectorAll(".eye-icon-password");

iconEyes.forEach((iconEye) => {
  iconEye.addEventListener("click", (event) => {
    // Use event.composedPath() instead of event.path, as event.path is undefined on Safari/Firefox
    // https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath
    let eventPath = event.composedPath()
    if (!(eventPath[1].children[0].hasAttribute("type"))) return;

    const input = eventPath[1].children[0];
    const $inputContainer = $(eventPath[1]);
    const $showEyeImg = $inputContainer.find("img.eye-show");
    const $hideEyeImg = $inputContainer.find("img.eye-hide");

    if (input.getAttribute("type") === "password") {
      input.setAttribute("type", "text");
      $showEyeImg.addClass("d-none");
      $hideEyeImg.removeClass("d-none");
    } else {
      input.setAttribute("type", "password");
      $showEyeImg.removeClass("d-none");
      $hideEyeImg.addClass("d-none");
    }
  })
});
